import { render, staticRenderFns } from "./AddClient.vue?vue&type=template&id=daf0e816&"
import script from "./AddClient.vue?vue&type=script&lang=ts&"
export * from "./AddClient.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports